import React, { useState } from 'react';
import { Link } from 'react-router';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import { setCategoryFilters } from '../../redux/features/filtersSlice';
import SearchBar from "../../common/Search";
import Pagination from "../../common/Pagination";
// import { useGetCategoriesQuery, useDeleteCategoryMutation, useChangeCategoryStatusMutation } from "../../redux/services/categoriesService/categories.Services";
import { useGetCategoriesQuery } from "../../redux/services/categoriesService/categories.Services";
function CategoriesList() {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.filters.category);
  const { data, isLoading, isError } = useGetCategoriesQuery(filters);
  const categories = data?.data || [];
  // const [deleteCategory] = useDeleteCategoryMutation();
  // const [changeCategoryStatus] = useChangeCategoryStatusMutation();
  const pagination = data?.pagination || {};
  const totalPages = pagination?.totalPages || 0;
  const showPagination = totalPages > 1;
  const hasData = setCategoryFilters?.length > 0;
  const isActive = (status) => {
    return status === "active" || status === "Active" || status === 1 || status === true;
  };
  const handlePageChange = (page) => {
    dispatch(
      setCategoryFilters({
        page,
      })
    );
  };
  const handleSearch = (value) => {
    dispatch(
      setCategoryFilters({
        search: value,
        page: 1,
      })
    );
  }
  if (isLoading) {
    return <h3>Loading...</h3>;
  }

  if (isError) {
    return <h3>Something went wrong</h3>;
  }

  return (
    <div>
      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              All Categories List
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">
                  Home
                </Link>
              </li>

              <li className="breadcrumb-item active">
                Categories List
              </li>
            </ol>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            className="btn btn-primary"
            onClick={() =>
              dispatch(
                openModal({
                  type: "create-category",
                  title: "Create Category",
                  data: {
                    refresh: true
                  }
                })
              )
            }
          >
            + Add Category
          </button>
        </div>
        <div className="mb-3">
          <SearchBar
            search={filters.search}
            setSearch={handleSearch}
            placeholder="Search  Categories..."
          />
        </div>
      </div>
      <div className="st-wrapper-card">
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle mb-0">
            <thead>
              <tr>
                <th>Sr.no.</th>
                <th>Category Name</th>
                <th>Deccreptions</th>
                <th>Image</th>
                <th>Status</th>
                <th>Change Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((item, index) => (
                <tr key={item.id}>
                   {(index + 1) + (filters.page - 1) * filters.limit}
                  <td className="fw-semibold">
                    {item.name}
                  </td>
                  <td className="fw-semibold">
                    {item.description}
                  </td>
                  <td>
                    <img
                      src={`${data?.imageBaseUrl}${item.image}`}
                      alt={item.name}
                      width="50"
                      height="50"
                      style={{
                        objectFit: "cover",
                        borderRadius: "8px"
                      }}
                    />
                  </td>
                  <td> {item.status === "active" || item.status === 1 ? "Active" : "Inactive"}</td>
                  <td style={{ width: "150px" }}>
                    <div className="city-status-switch">
                      <input
                        type="checkbox"
                        id={`status-${item.id}`}
                        className="city-status-input"
                        checked={isActive(item.status)}
                        onChange={() =>
                          dispatch(openModal({
                            type: "status-category",
                            title: "Change Category Status",
                            // data: {
                            //   id: item.id,
                            //   status: item.status,
                            //   apiUrl: "/category-status"
                            // }
                            data: {
                               id: item._id || item.id,
                              name: item.name,
                              status: item.status,
                              apiUrl: "/category-status",
                              message: `You want to change status of ${item.name}`
                            }
                          }))
                        }
                      />
                      <label
                        htmlFor={`status-${item.id}`}
                        className="city-status-label"
                      >
                        <span className="city-status-ball"></span>
                        <span className="city-status-text">
                          {isActive(item.status) ? "Active" : "Inactive"}
                        </span>
                      </label>

                    </div>
                  </td>


                  <td className="text-center">
                    <button
                      className="st-action-btn st-view-btn"
                      onClick={() =>
                        dispatch(openModal({
                          type: "view-category",
                          title: "View Category",
                          data: item
                        }))
                      }
                    >
                      <FaEye />
                    </button>
                    <button
                      className="st-action-btn st-edit-btn"
                      onClick={() =>
                        dispatch(openModal({
                          type: "edit-category",
                          title: "Edit Category",
                          data: {
                            id: item._id,
                            ...item
                          }
                        }))
                      }
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="st-action-btn st-delete-btn"
                      onClick={() =>
                        dispatch(openModal({
                          type: "delete-category",
                          title: "Delete Category",
                          // data: {
                          //   ...item,
                          //   deleteFunction: deleteCategory,
                          // }
                          data: {
                            id: item.id,
                            message: `You are deleting ${item.name}`,
                            apiUrl: "/category-delete",
                          }
                        }))
                      }
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-end mt-4">

            {showPagination && (
              <div className="d-flex justify-content-end mt-4">
                <Pagination
                  page={filters.page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoriesList;